module.exports = __webpack_public_path__ + "media/palenque/upper_waterfalls-b8763bcc.jpg";